export enum AutoCompleteSearchType {
  ContainsText = "containsText",
  StartsWith = "startsWith"
}

export enum CodeValueType {
  States = 1,
  Counties = 2,
  Cities = 3,
  Townships = 4,
  Countries = 5,
  None = 6
}

export enum CodeValueDisplayType {
  DescriptionOnly = "descriptionOnly",
  ValueOnly = "valueOnly",
  ValueAndDescription = "valueAndDescription",
  DescriptionAndValue = "descriptionAndValue"
}

export enum CodeValueSaveType {
  DescriptionOnly = "descriptionOnly",
  ValueOnly = "valueOnly",
  ValueAndDescription = "valueAndDescription",
  DescriptionAndValue = "descriptionAndValue"
}

export enum ConnectionStatus {
  UNKNOWN = 1,
  OFF_LINE = 2,
  ON_LINE = 3
}

export enum ApplicationContextField {
  internetStatus = "internetStatus",
  webServiceStatus = "webServiceStatus",
  currentSkin = "currentSkin",
  defaultLocation = "defaultLocation",
  currentUserId = "currentUserId",
  applicationId = "applicationId",
  currentFormIdentifier = "currentFormIdentifier",
  awsS3 = "awsS3"
}

export enum AttachmentFileType {
  Image = 1,
  Video = 2,
  Audio = 3,
  applicationId = "applicationId",
  Other = 4
}

export enum AWSStatus {
  pendingUpload = "pendingUpload",
  uploaded = "uploaded",
  deletependingstage1 = "deletependingstage1",
  deletepending = "deletepending",
  deleted = "deleted",
  previous = "previous"
}
